let errorlist = [];

const errors = {
    has: (name) => {
        return errorlist.some(item => item.name === name)
    },
    msg: (name) => {
        let error = errorlist.find((item) => {
           return item.name === name
        });
        return error ? error.msg : ''
    },
    push: (name, msg) => {
        errorlist = errorlist.filter((item) => {
            item.name !== name
        })
        errorlist.push({ name: name, msg: msg })
    },
    remove: (name) => {
        errorlist = errorlist.filter((item) => {
            item.name !== name
        })
    },
    clear: () => {
        errorlist = []
    }
}

export default {
    errors
}


// WEBPACK FOOTER //
// ./src/common/errors.js